const getMoreInformation = (data) => {
    return {
        "Request Method": data.httpMethod,
        "Concatenated String": data.concatenatedString,
        Signature: data.signature,
        URL: data.url
    }
}
export {getMoreInformation}